<script setup lang="ts">
import type { AppBlogPostListItem } from '~/types/app'

interface Props {
  posts: AppBlogPostListItem[]
}

const props = defineProps<Props>()
</script>

<template>
  <div class="relative mx-auto grid max-w-screen-lg gap-6 sm:grid-cols-2 lg:grid-cols-3">
    <AppPostCard
      v-for="post in props.posts"
      :key="`post_${post.id}`"
      :image-url="post.featured_image.url"
      :image-alt="post.featured_image.alt"
      :to="post.html_path"
    >
      <template
        v-if="post.tags?.length"
        #tag
      >
        {{ post.tags[0]?.name }}
      </template>

      <template #title>
        {{ post.title }}
      </template>

      <template #subtitle>
        <p v-if="post.sub_title">
          {{ post.sub_title }}
        </p>
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-else
          v-html="post.description"
        />
      </template>
    </AppPostCard>
  </div>
</template>
